<script setup>
import ErrorGeneric from '@/components/errors/ErrorGeneric'

const props = defineProps({
  error: Object
})
</script>

<template>
  <NuxtLayout>
    <div v-if="props.error">
      <ErrorGeneric :error="props.error"/>
    </div>
  </NuxtLayout>
</template>
